import React, { useEffect, useState, useRef } from 'react';
import { Play, Pause } from 'lucide-react';
interface AudioPlayerProps {
  src: string;
}
export function AudioPlayer({
  src
}: AudioPlayerProps) {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef<HTMLAudioElement>(null);
  const togglePlay = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };
  useEffect(() => {
    const audio = audioRef.current;
    if (audio) {
      audio.addEventListener('ended', () => setIsPlaying(false));
      return () => {
        audio.removeEventListener('ended', () => setIsPlaying(false));
      };
    }
  }, []);
  return <div className="mt-6 mb-2" data-id="element-195">
      <audio ref={audioRef} src={src} data-id="element-196" />
      <button onClick={togglePlay} className="group relative flex items-center gap-4 bg-white/90 backdrop-blur-xl border border-white/40 shadow-[0_8px_30px_rgb(0,0,0,0.04)] rounded-full pl-2 pr-6 py-2 transition-all duration-300 hover:scale-[1.02] hover:shadow-[0_8px_30px_rgb(0,0,0,0.08)]" data-id="element-197">
        {/* Play/Pause Button Circle */}
        <div className="w-10 h-10 rounded-full bg-black text-white flex items-center justify-center shadow-md group-hover:bg-[#3A3A3A] transition-colors" data-id="element-198">
          {isPlaying ? <Pause className="w-4 h-4 fill-current" data-id="element-199" /> : <Play className="w-4 h-4 fill-current ml-0.5" data-id="element-200" />}
        </div>

        {/* Text & Waveform */}
        <div className="flex flex-col items-start" data-id="element-201">
          <span className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-0.5" data-id="element-202">
            {isPlaying ? 'Escuchando' : 'Audio de bienvenida'}
          </span>
          <div className="flex items-center gap-2" data-id="element-203">
            <span className="text-sm font-medium text-[#3A3A3A]" data-id="element-204">
              Reproduce aquí
            </span>
            {/* Animated Waveform */}
            {isPlaying && <div className="flex items-end gap-[2px] h-3 ml-2" data-id="element-205">
                {[1, 2, 3, 4].map(i => <div key={i} className="w-[2px] bg-[#C9A86A] rounded-full animate-music-bar" style={{
              animationDelay: `${i * 0.1}s`,
              height: '100%'
            }} data-id="element-206" />)}
              </div>}
          </div>
        </div>
      </button>
    </div>;
}